import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Button, Dialog, DialogContent, DialogTitle, Slide } from "@material-ui/core";

import { Redirect } from "react-router-dom";
import { postPracticasDiscapacidad, setActiveStepDiscapacidad } from "../../../../actions/discapacidad/discapacidadActions";
import { STEPPER_INTEGRACION } from "../../data/constants";
import { startAlerta } from "../../../../actions/ui/alertas";
import { AutorizacionesCard } from "../../../autorizaciones/UI/AutorizacionesCard";
import { IntegracionAddPractica } from "./IntegracionAddPractica";
import IntegracionPractica from "./IntegracionPractica";
import { NotasMenuIntegracion } from "../components/NotasMenuIntegracion";
import Notes from "../../../autorizaciones/UI/Notes";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export const IntegracionPracticas = (props) => {
  const dispatch = useDispatch();
  const [showModalNotas, setShowModalNotas] = useState(false);

  const { solicitudSeleccionada = {} } = useSelector(
    (state) => state.discapacidad
  );
  const [redirect, setRedirect] = useState(false);

  const onClickSiguienteHandler = () => {
    if (solicitudSeleccionada?.practicas?.length)
      dispatch(
        postPracticasDiscapacidad(
          {
            practicas: solicitudSeleccionada?.practicas,
            idSolicitud: solicitudSeleccionada?.idSolicitud
          },
          null,
          true,
          setRedirect
        )
      );
    else
      dispatch(
        startAlerta(
          `Debe incluir una práctica.`,
          "error"
        )
      );
  };
  console.log(solicitudSeleccionada)
  return (
    <>
      {showModalNotas && (
        <Dialog
          open={showModalNotas}
          onClose={() => setShowModalNotas(false)}
          fullWidth
          maxWidth="sm"
          TransitionComponent={Transition}
          keepMounted
        >
          <DialogTitle>Notas</DialogTitle>
          <DialogContent>
            <NotasMenuIntegracion showBotonAgregar={false} desdeIngresoSolicitud={true} />
          </DialogContent>
        </Dialog>
      )}
      <AutorizacionesCard width={"75%"} integracion={true} >
        <div style={{display:'flex', justifyContent:'right',width:'85%'}}>
          {solicitudSeleccionada?.idSolicitud && (
            <Notes
              onClick={() => {
                setShowModalNotas(true);
              }}
            />
          )}
        </div>
        {(!Array.isArray(solicitudSeleccionada?.practicas) ||
          solicitudSeleccionada?.practicas.length === 0) &&
          <IntegracionAddPractica />
        }
        {solicitudSeleccionada?.practicas &&
          solicitudSeleccionada?.practicas.map((practica, index) => {
            return (
              <IntegracionPractica
                key={index}
                practica={practica}
              />
            );
          })}
        <div
          style={{ display: "flex", justifyContent: "center", margin: "2rem" }}
        >
          <Button
            variant="contained"
            color="secondary"
            style={{ marginRight: "3rem" }}
            onClick={() => {
              dispatch(setActiveStepDiscapacidad(STEPPER_INTEGRACION.DIAGNOSTICO_DOCUMENTACION));
            }}
          >
            Anterior
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={onClickSiguienteHandler}
          >
            Siguiente
          </Button>
        </div>
        {redirect && (
          <Redirect
            to={{
              pathname: "/discapacidad/home",
            }}
          />
        )}
      </AutorizacionesCard>
    </>
  );
};
